<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <h3 class="headline mb-0">請求・支払伝票登録</h3>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save" :disabled="!valid">登録</v-btn>
        <v-btn @click="back">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mt-2">
      <v-layout row wrap>
        <v-flex md4 sm12 xs12> </v-flex>
        <v-flex md4 sm12 xs12>
          <span class="sub-title">請求データ PF</span>
        </v-flex>
        <v-flex md4 sm12 xs12>
          <span class="sub-title">支払データ SC</span>
        </v-flex>
      </v-layout>
      <div class="sameLine">
        <v-form v-model="valid">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <date-picker
                  :disabled="!canEdit"
                  label="請求年月"
                  required
                  type="month"
                  v-model="eiaj.requestDate"
                  :rules="[(v) => v != null || `請求年月 is required`]"
                ></date-picker>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-text-field
                  :disabled="!canEdit"
                  label="納品キー番号"
                  v-model="eiaj.napinKey"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <remote-autocomplete
                  required
                  :disabled="!canEdit"
                  :label="$t('app.labels.bu.name')"
                  item-value="code"
                  url="divisions/kv?type=BU"
                  v-model="eiaj.buCode"
                  :rules="[
                    (v) =>
                      v != null || $t('app.labels.bu.name') + `is required`,
                  ]"
                />
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-text-field
                  :disabled="!canEdit"
                  label="P/O CD"
                  v-model="eiaj.poNo"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <remote-autocomplete
                  required
                  :disabled="!canEdit"
                  label="通貨"
                  url="currencies/kv"
                  v-model="eiaj.currencyCode"
                  :rules="[(v) => v != null || `通貨 is required`]"
                ></remote-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </div>
      <div class="sameLine left-line">
        <v-form>
          <v-container>
            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-text-field
                  :disabled="!canEdit"
                  label="課税金額"
                  type="number"
                  v-model="eiaj.requestTaxedAmount"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-text-field
                  :disabled="!canEdit"
                  label="非課税金額"
                  type="number"
                  v-model="eiaj.requestUntaxedAmount"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-text-field
                  :disabled="!canEdit"
                  label="税金"
                  type="number"
                  v-model="eiaj.requestTax"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-text-field
                  disabled
                  label="税込金額"
                  type="number"
                  v-model="requestTotalAmount"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-text-field
                  value=""
                  :disabled="true"
                  style="visibility: hidden"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </div>
      <div class="sameLine left-line">
        <v-form>
          <v-container>
            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-text-field
                  value=""
                  :disabled="true"
                  style="visibility: hidden"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-text-field
                  value=""
                  :disabled="true"
                  style="visibility: hidden"
                ></v-text-field
              ></v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-text-field
                  value=""
                  :disabled="true"
                  style="visibility: hidden"
                ></v-text-field
              ></v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-text-field
                  label="税込金額"
                  type="number"
                  v-model="paymentTotalAmount"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md12 sm12 xs12>
                <v-text-field
                  value=""
                  :disabled="true"
                  style="visibility: hidden"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      paymentTotalAmount: null,
      type: [
        { text: '未入金', value: 'UNPAYMENT' },
        { text: '戻入金', value: 'RETURNPAYMENT' },
        { text: '過入金', value: 'OVERPAYMENT' },
        { text: '純無償', value: 'SUBTRACTION' },
      ],
      eiaj: {
        requestTaxedAmount: null,
        requestUntaxedAmount: null,
        requestTax: null,
        paymentTaxedAmount: null,
        paymentUntaxedAmount: null,
        paymentTax: null,
      },
    }
  },
  methods: {
    isNullOrZero(value) {
      return (
        value === '' ||
        value === null ||
        value === undefined ||
        Number(value) === 0
      )
    },
    findNapinKey() {
      var napin = this.eiaj.napinKey.replace('+', '%2B')
      this.$http
        .get(
          `arap/write-off/get-by-napinkey?napinKey=${napin}&currencyCode=${this.eiaj.currencyCode}`
        )
        .then((res) => {
          this.setData(res)
        })
    },
    findById() {
      this.$http
        .get(`arap/write-off/get-by-id?id=${this.eiaj.id}`)
        .then((res) => {
          this.setData(res)
        })
    },
    save() {
      console.log(
        'totalAmount: ',
        this.requestTotalAmount,
        this.isNullOrZero(this.requestTotalAmount),
        ',',
        this.paymentTotalAmount,
        this.isNullOrZero(this.paymentTotalAmount)
      )
      if (
        !this.isNullOrZero(this.requestTotalAmount) &&
        !this.isNullOrZero(this.paymentTotalAmount)
      ) {
        this.$message(
          '',
          '請求データ PFと支払データ SC共に入力できません。いずれかを入力してください。'
        )
        return
      }
      if (
        this.isNullOrZero(this.requestTotalAmount) &&
        this.isNullOrZero(this.paymentTotalAmount)
      ) {
        this.$message(
          '',
          '請求データ PFと支払データ SC共に入力できません。いずれかを入力してください。'
        )
        return
      }
      this.$http
        .post('arap/write-off/write-off-result', {
          ...this.eiaj,
          paymentTotalAmount: this.paymentTotalAmount,
        })
        .then(() => {
          this.$message('', '登録が完了しました')
        })
        .catch(() => {
          this.$message('', '手動登録が失敗しました。')
        })
    },
    setData(res) {
      this.eiaj = {
        id: res.data.id,
        requestDate:
          res.data.archiveYear + '-' + this.pad(res.data.archiveMonth),
        napinKey: res.data.napinKey,
        buCode: res.data.buCode,
        poNo: res.data.poNo,
        currencyCode: res.data.currencyCode,
        requestTaxedAmount: res.data.requestTaxedAmount,
        requestUntaxedAmount: res.data.requestUntaxedAmount,
        requestTax: res.data.requestTax,
        requestTotalAmount: res.data.requestTotalAmount,
        paymentTaxedAmount: res.data.paymentTaxedAmount,
        paymentUntaxedAmount: res.data.paymentUntaxedAmount,
        paymentTax: res.data.paymentTax,
        paymentTotalAmount: res.data.paymentTotalAmount,
        paymentType: res.data.paymentType,
        requestSource: res.data.requestSource,
        paymentSource: res.data.paymentSource,
      }

      if (this.eiaj.currencyCode === 'JPY') {
        this.paymentTotalAmount = (
          Number(this.eiaj.paymentTaxedAmount) +
          Number(this.eiaj.paymentUntaxedAmount) +
          Number(this.eiaj.paymentTax)
        ).toFixed(0)
      } else {
        this.paymentTotalAmount = (
          Number(this.eiaj.paymentTaxedAmount) +
          Number(this.eiaj.paymentUntaxedAmount) +
          Number(this.eiaj.paymentTax)
        ).toFixed(2)
      }
    },
    pad(num) {
      if (num >= 10) {
        return num
      } else {
        return '0' + num
      }
    },
    back() {
      this.$router.push('/B1400')
    },
    initData() {
      if (this.$route.query.id) {
        this.eiaj.id = this.$route.query.id
        this.findById()
      }
    },
  },
  computed: {
    isOld() {
      return !!this.eiaj.id
    },
    canEdit() {
      return (!this.isFinished && this.isRequestManual) || !this.isOld
    },
    isPaymentManual() {
      return this.eiaj.paymentSource === 'MANUAL'
    },
    isRequestManual() {
      return this.eiaj.requestSource === 'MANUAL'
    },
    isFinished() {
      return this.eiaj.paymentType === 'CLEAROUT'
    },
    isUnpayment() {
      return this.eiaj.paymentType === 'UNPAYMENT'
    },
    isOverpayment() {
      return this.eiaj.paymentType === 'OVERPAYMENT'
    },
    requestTotalAmount() {
      if (this.eiaj.currencyCode === 'JPY') {
        return (
          Number(this.eiaj.requestTaxedAmount) +
          Number(this.eiaj.requestUntaxedAmount) +
          Number(this.eiaj.requestTax)
        ).toFixed(0)
      } else {
        return (
          Number(this.eiaj.requestTaxedAmount) +
          Number(this.eiaj.requestUntaxedAmount) +
          Number(this.eiaj.requestTax)
        ).toFixed(2)
      }
    },
  },
  mounted() {
    this.initData()
  },
}
</script>
<style>
.sameLine {
  display: inline-block;
  width: 33%;
}
.left-line {
  border-left: 1px dotted black !important;
}
.sub-title {
  display: block;
  margin-left: 20%;
}
</style>

